import { render, staticRenderFns } from "./DropdownUser2.vue?vue&type=template&id=661c0b48&"
import script from "./DropdownUser2.vue?vue&type=script&lang=js&"
export * from "./DropdownUser2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownUser2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DropdownUser2.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBottomSheet,VBtn,VCombobox,VIcon,VList,VListItem,VSubheader})
